// Time window in seconds within which a follow-up search is considered a query refinement.
// A refinement is when a user modifies their search query after seeing results,
// indicating the initial query wasn't precise enough.
export const QUERY_REFINEMENT_WINDOW_SECONDS = 30;
